import { ShieldOff } from "lucide-react";
import { useTranslation } from "react-i18next";

export function EnterpriseNoAccessPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <ShieldOff className="h-8 w-8 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-semibold text-foreground">
        {t("enterpriseStaff.errors.noAccess.title")}
      </h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        {t("enterpriseStaff.errors.noAccess.body")}
      </p>
    </div>
  );
}
